(function () {
  let upsellSwiper = null;

  function getUpsellContainer() {
    return document.querySelector('.cart-notification__upsells-container.swiper');
  }

  function initOrRefreshUpsellSwiper() {
    const el = getUpsellContainer();
    if (!el || typeof Swiper === 'undefined') return;

    const slideCount = el.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    if (upsellSwiper && upsellSwiper.el === el) {
      upsellSwiper.update();
      upsellSwiper.slideTo(0, 0);
      return;
    }

    if (upsellSwiper) {
      upsellSwiper.destroy(true, true);
      upsellSwiper = null;
    }

    const prevEl = el.querySelector('.swiper-button-prev');
    const nextEl = el.querySelector('.swiper-button-next');

    // eslint-disable-next-line no-undef
    upsellSwiper = new Swiper(el, {
      slidesPerView: 1.08,
      spaceBetween: 12,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        481: {
          slidesPerView: 2.08,
          spaceBetween: 12,
        },
        1025: {
          slidesPerView: 1.08,
          spaceBetween: 12,
        },
      },
      navigation:
        slideCount > 1 && prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : false,
    });
  }

  document.addEventListener('cart-notification:opened', () => {
    requestAnimationFrame(() => {
      initOrRefreshUpsellSwiper();
    });
  });
})();
